import { Image, LinkButton, UIHeading2, UIHeading3 } from '@cian/ui-kit';
import * as React from 'react';

import styles from './EtazhiBlackFridayCard.css';

import type { IEtazhiBlackFridayPromoOffersDataByPlatform } from 'shared/types/etazhiBlackFriday';

interface IEtazhiBlackFridayCardProps {
  promoOffersData: IEtazhiBlackFridayPromoOffersDataByPlatform | null;
  serpLink: string;
  onLogoClick(): void;
  onButtonClick(): void;
}

/**
 * Код появился к проекту "Чёрная пятница" для компании "Этажи".
 * @todo: удалить в задаче CD-250843
 */
export const EtazhiBlackFridayCard: React.FC<IEtazhiBlackFridayCardProps> = props => {
  const { onLogoClick, onButtonClick, promoOffersData, serpLink } = props;

  if (!promoOffersData || !promoOffersData.enabled) {
    return null;
  }

  const { bgImageUrl, logoImageUrl, title, subtitle, buttonText, logoLink } = promoOffersData;

  return (
    <div
      className={styles['container']}
      data-testid="EtazhiBlackFridayPromoOffersCard"
      style={{ backgroundImage: `url(${bgImageUrl})` }}
    >
      <a
        className={styles['logo']}
        data-testid="EtazhiBlackFridayPromoOffersCardLogo"
        target="_blank"
        rel="noopener noreferrer"
        href={logoLink}
        onClick={onLogoClick}
      >
        {logoImageUrl && <Image src={logoImageUrl} objectFit="contain" preloader theme="light" />}
      </a>
      {title && (
        <div className={styles['title']}>
          <UIHeading2 color="text-primary-default">{title}</UIHeading2>
        </div>
      )}
      {subtitle && (
        <div className={styles['subtitle']}>
          <UIHeading3 color="text-primary-default">{subtitle}</UIHeading3>
        </div>
      )}
      {buttonText && (
        <div className={styles['control']}>
          <LinkButton
            size="XS"
            fullWidth={false}
            theme="fill_secondary"
            href={serpLink}
            target="_blank"
            data-testid="EtazhiBlackFridayPromoOffersCardButton"
            onClick={onButtonClick}
          >
            {buttonText}
          </LinkButton>
        </div>
      )}
    </div>
  );
};
